/*
 * @Description: SO ME 指数
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-04-02 11:20:03
 * @LastEditTime: 2019-11-21 16:17:25
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Soumi.css';
import { getCarBrandIndexRank, getCarProductIndexRank, getConsumeIndexRank, getScienceIndexRank, getPeriods } from '../../controller';

import colunms from './typeList';
import * as colunmsList from './colunms';
// import html2canvas from 'html2canvas'


import { saveFile, convertCanvasToImage } from '../../utils';
import Loading from '../../components/Loading/Loading';

// controller 列表
const controllerList = {
  BRAND: getCarBrandIndexRank,
  PRODUCT: getCarProductIndexRank,
  CONSUME: getConsumeIndexRank,
  SCIENCE: getScienceIndexRank
};

/**
 * 返回url地址
 * @param {string} id 
 */
const imgUrl = (id) => id ? `/digitalAssets/resources/img/LOGO/${id}.png` : '';

/**
 * 将数据展开
 * @param {*} list 
 */
const getNameMap = (list, parent = []) => {
  let result = {}

  list.forEach(element => {
    if (element.list) {
      result = Object.assign(getNameMap(element.list, parent.concat([element.title])), result)
    } else {
      result[element.name] = parent.length > 0 ? Object.assign({parent: [].concat(parent)}, element) : element
    }
  })
  return result
}

// select->option数据列表
const nameMap = getNameMap(colunms)

class Soumi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      colunms: [],
      currentBrand: 1,
      list: [],
      period: 0,
      periods: [],
      width: 480,
      brandNameWidth: 75,
      style: {
        height: Math.floor(480/18)
      },
    }

    this.screen = null

    this.changePeriod = this.changePeriod.bind(this);
    this.changeHandle = this.changeHandle.bind(this);
    this.widthChangeHandle = this.widthChangeHandle.bind(this);
    this.changeBrandNameWidth = this.changeBrandNameWidth.bind(this);
    this.capture = this.capture.bind(this);
  }

  componentDidMount () {
    this.getPeriods()
  }

  /**
   * 获取期数列表,返回取到列表后加载列表数据
   */
  getPeriods () {
    getPeriods()
      .then(res => {
        if (!res) return
        const list = (res || []).sort((a, b) => b - a)

        this.setState({
          periods: list,
          period: list[0]
        }, () => {
          const select = this.refs.select
          // @ts-ignore
          const value = select.value
          this.changeHandle(value)
        })
      })
  }

  // 将三层数据递归为一层，并返回option element
  renderOptGroup(list, title) {
    const tit = title ? `${title}-` : ''

    return list.map((item) => {
      if (item.colunms) {
        return <option key={item.name} value={item.name}>{tit + item.title}</option>
      } else {
        return this.renderOptGroup(item.list, tit + item.title);
      }
    });
  }

  /**
   * 监听select数据改变
   * @param {string|Object} e 
   */
  changeHandle(e) {
    
    const value = typeof e !== 'string' ? e.target.value : e

    this.selectChange(nameMap[value].value)

    const colunms = colunmsList[nameMap[value].colunms]

    this.setState({
      currentBrand: value,
      colunms: colunms
    })
  }

  /**
   * 根据字符串处理数据
   * @param {String} typeStr 
   */
  selectChange (typeStr) {
    this.setState({
      loading: true
    })
    const arr = typeStr.split('-');

    const controller = controllerList[arr[0]];
    const period = this.state.period


    let query = {
      key: arr[1],
      periods: period
    };
    if (arr.length === 3) {
      query.info = arr[2]
    }
    
    // 获取数据
    controller(query)
      .then(res => {
        if (!res) return this.setState({ loading: false })
        
        this.setState({
          list: res,
          loading: false
        })
      })
  }

  /**
   * 期数更改的时候重新获取列表
   */
  changePeriod (e) {
    this.setState({
      period: e.target.value
    }, () => {
      this.changeHandle(this.state.currentBrand)
    })
  }

  widthChangeHandle = (() => {
    let times;
    const _this = this;
    return (e) => {
      clearTimeout(times);
      const width = e.target.value
      times = setTimeout(() => {
        if (width >= 1250) {
          _this.setState({
            width: width,
            style: {
              height: '40px'
            }
          })
        } else {
          _this.setState({
            width: width,
            style: {
              height: width / 18 + 'px'
            }
          })
        }
      }, 300)
    }
  })()

  /**
   * 设置品牌名称宽度
   * @param {*} e 
   */
  changeBrandNameWidth (e) {
    this.setState({
      brandNameWidth: e.target.value
    })
  }

  
  /**
   * 截屏并保存
   */
  capture () {
    const html2canvas = require('html2canvas')
    const nametype = nameMap[this.state.currentBrand]
    let list = this.state.list
    let _list = list.slice(0, 20)
    if (nametype.title === '主榜单') {
      _list = list.slice(0, 100)
    }

    this.setState({
      list: _list
    }, () => {
      html2canvas(this.screen, {
        scale: 2
      })
        .then(canvas => {
          const src = convertCanvasToImage(canvas).src
          const parent = nametype.parent || []

          // 如果不是主榜单需要添加上分类
          const fileName = nametype.title !== '主榜单' && parent.length > 0 ? `${parent[0]}-` : '' 

          saveFile(src, `SO-ME指数排行榜-${fileName + nametype.title}`)

          this.setState({
            list: list
          })
        })
    })
  }

  /**
   * 过滤字段
   * @param {String} name 
   */
  filterStyle (name) {
    const width = this.state.brandNameWidth
    let style = this.state.style

    if (name == 'setWidth') {
      style = Object.assign({
        width: width + 'px'
      }, style)
    }

    return style
  }

  /**
   * 创建TD
   * @param {Array} list 
   * @param {Element} data 
   */
  renderTD (list, data) {
    return list.map((item, index) => {
      return (
        <td style={this.filterStyle(item.name)} key={index}>
          { item.name == 'brandName' && <img src={imgUrl(data.brandId)} /> }
          { data[item.name] }
        </td>
      )
    })
  }

  /**
   * 根据数据创建列表
   * @param {Array} list 
   */
  renderTR (list) {
    const tableColunms = this.state.colunms
    return list.map((item, index) => (<tr key={index}>{ this.renderTD(tableColunms, item) }</tr>));
  }


  render() {
    const tableColunms = this.state.colunms
    const loading = this.state.loading
    const style = this.state.style
    const width = this.state.width
    const periods = this.state.periods
    const period = this.state.period
    const currentBrand = this.state.currentBrand

    return (
      <div className={s.root}>
        {/* tool begin */}
        <div>
          <select className={s.select} value={period} onChange={this.changePeriod}>
            {periods.map((item, index) => <option value={item} key={index}>{`第${item}期`}</option> )}
          </select>

          <select className={s.select} value={currentBrand} onChange={this.changeHandle} ref="select">
            {this.renderOptGroup(colunms)}
          </select>

          <span className={s.select}>列表宽度:</span>
          <input className={s.select} 
            onChange={this.widthChangeHandle} 
            value={width} 
            type="range"
            min="400"
            max="1300"
          />

          <span className={s.select}>品牌名称宽度:</span>
          <input className={s.select} type="number" value={this.state.brandNameWidth} onChange={this.changeBrandNameWidth} />

          <button className={s.select} onClick={this.capture}>截图</button>

        </div>
        {/* tool end */}

        <div className={s.rank_head}>
          <h2 className={s.rank_tit} > SO-ME指数排行榜 </h2>
        </div>

        <div ref={ele => this.screen = ele} className={s.dbTable} style={{width: (width >= 1250 ? '100%' : width + 'px')}}>
          <Loading show={loading} />
          <table cellSpacing="0" cellPadding="0">
            <thead key='1'>
              <tr>
                {
                  tableColunms.map((item, index) => {
                    if (index === 0) {
                      return (
                        <th style={Object.assign({width: '40px'}, style)} key={index} dangerouslySetInnerHTML={{ __html: item.title }} />
                      )
                    } else if (index === 1) {
                      return (
                        <th style={this.filterStyle('setWidth')} key={index} dangerouslySetInnerHTML={{ __html: item.title }} />
                      )
                    } else {
                      return (
                        <th style={style} key={index} dangerouslySetInnerHTML={{ __html: item.title }} />
                      )
                    }
                  })
                }
              </tr>
            </thead>
            <tbody>
              {this.renderTR(this.state.list)}
            </tbody>
          </table>

        </div>
      </div>
    );
  }
}

export default withStyles(s)(Soumi);



// WEBPACK FOOTER //
// src/routes/soumi/Soumi.js